<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col  md="12">
        <b-card>
          <div slot="header">Project/Work in Progress  
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <!-- <b-button variant="btn btn-primary mr-1" @click="reclass">Reclass</b-button> -->
              <button class="btn btn-primary mr-1" @click="exportxls()">
                  <i class="fa fa-file-excel-o"></i>
                  Export
              </button>
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
        <b-row >
          <b-col lg="5">
              <b-input-group >
                  <b-input-group-prepend><span class="pt-2 mr-2">Filter</span></b-input-group-prepend>
                  <b-form-input v-model="filter.pip_code" placeholder="PIP Code"></b-form-input>
                  <b-form-input v-model="filter.pip_name" class="ml-1" placeholder="PIP Name" style="width:35% !important;"></b-form-input>
              </b-input-group>
          </b-col>
          <b-col lg="3">
              <b-input-group >
                  <b-input-group-prepend><span class="pt-2 mr-2">PIP Account</span></b-input-group-prepend>
                  <b-form-select v-model="filter.pipkodeacc" :plain="true" :options="pipAccountsFilt" ></b-form-select>
              </b-input-group>
          </b-col>
          <b-col md="4">
              <b-input-group >
                <b-input-group-prepend><label>Reclass Status</label></b-input-group-prepend>
                  <b-form-select v-model="filter.reclass" :plain="true" :options="reclassStatus" ></b-form-select>
                  <b-input-group-append> <b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
                  <b-input-group-append> <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear</b-button></b-input-group-append>
              </b-input-group>
          </b-col>
        </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"

            @row-clicked="rowClicked"
          >
            <!-- <template v-slot:cell(isactive)="data">
              {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
            </template> -->
          <template v-slot:cell(saldoDB)="data">{{ data.item.saldoDB | numFormat("0,0.00") }}</template>
          <template v-slot:cell(saldoCR)="data">{{ data.item.saldoCR | numFormat("0,0.00") }}</template>

        <template v-slot:cell(isactive)="data">
          <span v-if="data.item.isactive==1"><i class="fa fa-check "></i></span>
        </template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" @click.stop="reclass(data.item)">
                reclass
              </a>
              |
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>              
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">            
              <b-pagination v-if="pagination" 
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
        </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">PIP - Add/Edit Form </div>
              <b-form-group  label-cols=3  label="PIP Code" >
                  <b-form-input v-model="frmdata.pip_code"  disabled></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="PIP Name" >
                  <b-form-input v-model="frmdata.pip_name" :state="!$v.frmdata.pip_name.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="GL Account# " >
                  <b-form-select v-model="frmdata.pipkodeacc" :state="!$v.frmdata.pipkodeacc.$error" :plain="true" :options="pipAccounts" ></b-form-select>
              </b-form-group>
              <b-form-group  label-cols=3  label="Active" >
                  <b-form-select v-model="frmdata.isactive" :plain="true" :options="activeStatus" ></b-form-select>
              </b-form-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import toastr from "mini-toastr";
import pip from "../../apis/pip";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        pip_name: { required },
        pipkodeacc: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      frmdata:{pip_code: '',pip_name:'', pipkodeacc:'' },
      pagination:false,
      tblData: {
        tablename:'pip-wip',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'modified',
        sortDesc: false,
      },
    tblFields:[
          {
            key: "pip_code",
            label: "Code",
            sortable: true
          },
          {
            key: "pip_name",
            label: "Name",
            sortable: true
          },
          {
            key: "pipkodeacc",
            label: "Account#",
            sortable: true
          },
          {
            key: "pipnamaacc",
            label: "Account Name",
            sortable: true
          },
          {
            key: "saldoDB",
            label: "Debit",
            sortable: true
          },
          {
            key: "saldoCR",
            label: "Credit",
            sortable: true
          },
          {
            key: "reclassJv",
            label: "Reclass JV",
            sortable: true
          },          
          {
            key: "isactive",
            label: "Active",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:100px",
            thClass: "text-center",
          }          
        ],
      filter:{ pip_code:'', pip_name:'', reclass:''},
      reclassStatus : [{ value: '0', text: 'OPEN(NOT RECLASS)' },{ value: '1', text: 'CLOSE(RECLASSED)' },{ value: '', text: '-- ALL --' },],
      activeStatus : [{ value: '', text: '-- ALL --' }, { value: '0', text: 'Non Active' },{ value: '1', text: 'Active/In Use' }],
      pipAccounts : [],pipAccountsFilt : [{ value: '', text: '-- ALL --' }],
    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  watch:{
      "frmdata.pipkodeacc": function(newval) {
          const acc = this.pipAccounts.find(d => d.value === newval);
          if (acc) {
            this.frmdata.pipnamaacc = acc.text;
          }
      },
  },
  created: async function (){
        const pipAccounts = await pip.pipAccount();
        // console.log('pipAccounts: ', pipAccounts);
        pipAccounts.forEach(pip => {
          this.pipAccounts.push({ value: pip.kodeacc, text: pip.namaacc })
          this.pipAccountsFilt.push({ value: pip.kodeacc, text: pip.namaacc })
        });
  },
  methods: {
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            // let str ='isdeleted=0';
            // if (this.filter.pip_code){
            //   str += str ? '&' : '';
            //   str = str + 'pip_code=%' + encodeURIComponent(this.filter.pip_code)+'%';
            // }
            // if (this.filter.pip_name){
            //   str += str ? '&' : '';
            //   str = str + 'pip_name=%' + encodeURIComponent(this.filter.pip_name)+'%';
            // }
            // if (this.filter.pipkodeacc){
            //   str += str ? '&' : '';
            //   str = str + 'pipkodeacc=%' + encodeURIComponent(this.filter.pipkodeacc)+'%';
            // }
            // if (this.filter.reclass){
            //   str += str ? '&' : '';
            //   str = str + 'reclass=%' + encodeURIComponent(this.filter.reclass)+'%';
            // }
            // this.tblData.customQuery=str;      

            await pip.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   
    data: async function() {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
          const filter = this.$store.state.filter;
          let filtered=false;
          for (var key in filter.pipList) {
              this.tblData[key] = filter.pipList[key];
              filtered=true;
          }
          if (filtered === true) {
            this.tblData.tgl1=filter.pipList.tgl1 || '';
            this.tblData.tgl2=filter.pipList.tgl2 || '';
            this.showFilter=filtered;
            delete filter.pipList;
            this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                // this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
                  const list = await pip.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                // this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
                  const list = await pip.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },

    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search() {
      this.tblData.page=1;
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        this.frmdata.isactive=1;                      
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        // for (var key in this.frmdata) {
        //     this.frmdata[key] = '';
        // }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.departid;
      this.showForm=true;
      this.showList=false;
    },
    reclass: function(data) {
      this.model=data;
        // toastr.info("Belum diimplementasikan");
        if (this.model) {
            this.saveFilter();
            router.push({name :"accounting.pip-reclass", params: this.model});
        } else {
            toastr.warn('Please select a row that want to be RECLASS!');
        }

    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'pip_code','pip_name','reklass', 'isactive'];
      let filtered = false;
      const pipList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              pipList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          pipList.page=this.tblData.page;
          pipList.limit=this.tblData.limit;
          pipList.sortBy=this.tblData.sortBy;
          pipList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.pipList=pipList;
          this.$store.commit("filter", filter);
      }
    },    

    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              // if (this.frmdata.idlama) {
              //   await pip.update(
              //        {tablename:'pip-wip', 
              //        key:this.frmdata.idlama, 
              //        data:{pip_code:this.frmdata.pip_code, pip_name:this.frmdata.pip_name,
              //        pipkodeacc: this.frmdata.pipkodeacc, pipnamaacc:this.frmdata.pipnamaacc,
              //        isactive:this.frmdata.isactive}
              //         });
              // } else {
              //   await pip.insert(
              //     { tablename:'pip-wip',                      
              //        data:{pip_code:this.frmdata.pip_code, pip_name:this.frmdata.pip_name,
              //        pipkodeacc: this.frmdata.pipkodeacc, pipnamaacc:this.frmdata.pipnamaacc,
              //        isactive:this.frmdata.isactive}
              //     });
              // }
                await pip.save(this.frmdata);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await pip.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    clearFilter(ctx) {
        this.filter.pip_name= '';
        this.filter.pipkodeacc= '';
        this.filter.pipnamaacc= '';
        this.refresh();
    },    
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
